
import { useEffect, useReducer } from "react";
import { linearValidationUpdateAct } from "../../store/communication-data/actions";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { CommonInfoCmpProps } from "../../types/commonTypes";
import { LinearConducenteInfo, LinearContactInfo, completeLinearBaseValidationSchema, linear_conducenteCtp_contactInfoItems } from "../../types/communication/communicationDataType";
import { genericStateReducer } from "../contact/genericStateReducer";
import { selectCommunicationData } from "../../store";
import LinearCtpInfoCmp from "../contact/LinearCtpInfoCmp";

export const LinearConducenteStateAction = {
    UPDATE_STATE: '@@conducenteInfo/UPDATE_STATE'
}

const LinearConducenteCmp = (props: CommonInfoCmpProps<LinearConducenteInfo>) => {
    const communicationData = useAppSelector(selectCommunicationData)
    const { driverValidationInfo, communication } = communicationData
    const dispatch = useAppDispatch();
    const { initValues, onChange } = props
    const [conducenteState, conducenteDispatch] = useReducer(genericStateReducer<LinearConducenteInfo>(LinearConducenteStateAction), initValues);

    useEffect(() => {
        onChange && onChange(conducenteState)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [conducenteState])

    useEffect(() => {
        if (driverValidationInfo) {
            const initDriverInfo = conducenteState.conducente_contactInfo
            initDriverInfo.name = initDriverInfo.name || communication?.caiData?.data.vehicleA?.driver?.name || ''
            initDriverInfo.surname = initDriverInfo.surname || communication?.caiData?.data.vehicleA?.driver?.surname || ''
            initDriverInfo.phoneNumber = initDriverInfo.phoneNumber || communication?.caiData?.data.vehicleA?.driver?.telNumber || ''
            conducenteDispatch({
                type: LinearConducenteStateAction.UPDATE_STATE, payload: {
                    conducente_contactInfo: new LinearContactInfo(initDriverInfo)
                }
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    return (
        <>
            <LinearCtpInfoCmp
                initValues={conducenteState?.conducente_contactInfo}
                contactItems={linear_conducenteCtp_contactInfoItems}
                onContactChange={(newContactInfo: Partial<LinearContactInfo>) =>
                    conducenteDispatch({
                        type: LinearConducenteStateAction.UPDATE_STATE, payload: {
                            conducente_contactInfo: new LinearContactInfo({
                                ...conducenteState,
                                ...newContactInfo
                            })
                        }
                    })}
                validationSchema={completeLinearBaseValidationSchema}
                onValiddationStateChange={(formState: any) =>
                    dispatch(linearValidationUpdateAct({ agree_contactInfo: formState?.isValid }))
                }
            />
        </>
    )
}

export default LinearConducenteCmp

